import { useState } from "react";

function useLoading(): [boolean, () => void, () => void] {
  const [loading, setLoading] = useState(false);

  const startLoading = () => {
    setLoading(true);
  };

  const stopLoading = () => {
    setLoading(false);
  };

  return [loading, startLoading, stopLoading];
}

export default useLoading;
